import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import {
  CompletePasswordResetPage,
  ForgotPasswordPage,
  LoginPage,
  RequestPasswordResetPage
} from "@app/features/auth";
import { NoAccess, NoAuth, NotFound } from "@ui/errors";
import constants from "@constants/constants";

import Auth from "config/auth";

import generatePrivateRoutes, { routeArray } from "../protected-routes";

const {
  PAGE_ROUTES: {
    LOGIN_ROUTE,
    FORGET_PASSWORD_ROUTE,
    NOT_FOUND_ROUTE,
    NO_ACCESS_ROUTE,
    NOT_AUTH_ROUTE,
    REQUEST_PASSWORD_RESET_ROUTE,
    COMPLETE_PASSWORD_RESET_ROUTE
  }
} = constants;

function RootRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={LOGIN_ROUTE} element={<LoginPage />} />
        <Route path={FORGET_PASSWORD_ROUTE} element={<ForgotPasswordPage />} />
        <Route path={REQUEST_PASSWORD_RESET_ROUTE} element={<RequestPasswordResetPage />} />
        <Route path={COMPLETE_PASSWORD_RESET_ROUTE} element={<CompletePasswordResetPage />} />
        <Route path={NOT_AUTH_ROUTE} element={<NoAuth />} />
        <Route path={NO_ACCESS_ROUTE} element={<NoAccess />} />
        <Route path={NOT_FOUND_ROUTE} element={<NotFound />} />
        <Route
          path="*"
          element={
            !Auth.isAuthenticated() ? <Navigate to={LOGIN_ROUTE} /> : <Navigate to={NOT_FOUND_ROUTE} />
          }
        />
        {generatePrivateRoutes(routeArray)}
      </Routes>
    </BrowserRouter>
  );
}

export default React.memo(RootRouter);
